import { SettingsParser } from "./settings-parser";
import { SignalCommonSettings } from "../settings/signal-common-settings";

export class CommonSignalParser extends SettingsParser {
  constructor() {
    super();
    this.parsedFieldNames = ["id", "title"];
  }

  static createSettings(settings) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {
      id: settings.id,
      title: settings.title
    };
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = CommonSignalParser.createSettings(settings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new SignalCommonSettings(parsedSettings);
  }
}
